// those file are generate by npm run i18n
  export default {
  "user": {
    "subtitle": "BILAN DE L'ANNÉE",
    "note": "* Toutes les statistiques de cet aperçu datent du 2025/12/31."
  },
  "handCard": {
    "text": "{date}\nVous avez joué à NUTS POKER la première fois en 2025."
  },
  "report": {
    "loginTime": "Depuis, NUTS POKER a été à vos côtés pendant \n{loginDay}",
    "loginTips": "* Jours de connexion à NUTS POKER en 2025.",
    "enjoyTime": "{loginTime}\nC'est l'heure à laquelle vous profitez le plus et l'heure à laquelle vous préférez lancer NUTS POKER !",
    "firstHandDate": "{first_hand_date}\nVous avez reçu votre première main de l'année en jouant à {first_hand_type}.\n{first_hand_cards}"
  },
  "hands": {
    "v1": "Cette année dans NUTS POKER,\nvous avez joué un total de\n{hands}\nVotre amour pour le poker\n a dépassé celui de \n{percentage} des joueurs.",
    "v2": "Cette année dans NUTS POKER,\nvous avez joué un total de\n{hands}\nMerci de faire partie de l'aventure !",
    "v3": "Cette année dans NUTS POKER,\nvous avez joué un total de \n{hands}\nNUTS POKER s’efforcera de s’améliorer et de vous offrir une expérience encore plus agréable l’année prochaine !"
  },
  "hardTime": {
    "date": "{one_day_hands}\nC'était le jour où vous avez le plus souvent joué à NUTS POKER et",
    "hands": "où vous avez joué un total de\n{one_day_hands_num} {longHands}"
  },
  "favoriteGame": "Parmi votre total de mains jouées,\n{handsNum} {hands} ont été jouées dans votre format de partie préféré : {game}",
  "kkWin": {
    "v1": "En 2025,\nvous avez obtenu des rois fermés\n{all} {longTimes}\net vaincu vos adversaires grâce à des rois fermés\n{win} {longTimesTwo}",
    "v2": "Cette année, vous avez fait tapis\n{all} {threeTimes}\nVotre taux de victoire de tapis est de :\n{percentage}\nLe poker est un jeu pour les intrépides !"
  },
  "achievement": {
    "spinup": "{spinup_date}\nétait le jour où vous avez eu le plus de chance.",
    "spinup_2": "Ce jour-là, vous avez obtenu le multiplicateur {spinup_ratio} en SpinUp et avez gagné :\n{spinup_reward}",
    "mtt": "{mtt_date}\nC'était votre moment fort de l'année.",
    "mtt_2": "Ce jour,\nvous vous êtes classé {no} {mtt_rank} sur {mtt_name}\net avez gagné\n{mtt_reward}",
    "rg": "{rg_date}\nUne journée remarquable pour vous dans le poker!",
    "rg_2": "Ce jour-là, vous avez gagné le plus grand pot de l'année :\n{rg_reward}"
  },
  "lucky": {
    "title": "Chaque main\na son histoire.",
    "luckyHand": "MAIN\nCHANÇEUSE",
    "unLuckyHand": "MAIN\nMALCHANÇEUSE",
    "luckyRate": "Taux de victoire \n{lucky_rate}",
    "unLuckyRate": "Taux de victoire \n{unlucky_rate}",
    "luckyText": "{lucky_hand} a été le héros.\n\nVous avez gagné {lucky_rate} du temps lorsque vous l'aviez avec vous !",
    "unLuckyText": "Attention à {unlucky_hand}…\nVous avez seulement gagné {unlucky_rate} du temps lorsque vous l'aviez avec vous.",
    "note": "*Seules les mains de départ distribuées 10 fois ou plus sont admissibles."
  },
  "futureStory": "NUTS POKER est impatient de poursuivre l'écriture du récit de votre aventure de poker en 2026.",
  "version3": {
    "text": "Malheureusement, vous n'avez laissé aucun souvenir avec NUTS POKER en 2025.",
    "continue": "Rejoignez-nous pour écrire\nvotre propre aventure NUTS POKER en 2026 !",
    "tips": " * Toutes les statistiques datent du 31/12/2024."
  },
  "button": {
    "save": "Enreg. Image",
    "copy": "Copier et partager"
  },
  "unit": {
    "days": "jours",
    "hands": "mains",
    "longHands": "mains",
    "longTimes": "fois",
    "longTimesTwo": "fois",
    "threeTimes": "fois",
    "times": "fois",
    "multiplier": "multiplicateur ",
    "num": "n°",
    "num2": "",
    "bets": "mises",
    "skUnits": ""
  },
  "toast": {
    "linkCopied": "Lien copié",
    "imageSaved": "Image sauvegardée"
  }
}
  